const points = [
  {
    icon: "ri-eye-line",
    title: "看得懂",
    desc: "用大白话讲清吃瓜投稿的稿费单价与收益构成，不堆术语、不绕弯。",
  },
  {
    icon: "ri-hand-coin-line",
    title: "算得清",
    desc: "把投稿到收钱的关键节点拆开，结算与提现规则掰开揉碎给你看。",
  },
  {
    icon: "ri-umbrella-line",
    title: "防得住",
    desc: "投稿前先看清避坑清单，守住隐私与法律底线，稿费才拿得安心。",
  },
];

export default function IntroBand() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-16 pt-4 md:px-6 md:pb-20">
      <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.2fr]">
        <div className="relative">
          <div className="overflow-hidden rounded-[2rem] bg-accent-100 ring-1 ring-accent-200">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20editorial%20illustration%20of%20a%20person%20reading%20hot%20gossip%20articles%20on%20tablet%20with%20chat%20bubbles%2C%20melon%20green%20and%20cream%20palette%2C%20soft%20minimal%20flat%20modern%20style%2C%20warm%20friendly%20learning%20guide%20atmosphere&width=1000&height=820&seq=intro-gossip-02&orientation=landscape"
              alt="吃瓜投稿攻略讲解：投稿者查看稿费单价与结算规则的场景插画"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-accent-600">关于本站</p>
          <h2 className="mt-2 text-3xl text-foreground-950 md:text-4xl">
            一份讲真话的吃瓜投稿指南
          </h2>
          <p className="mt-3 text-foreground-600 md:text-lg">
            市面上讲吃瓜投稿的帖子不少，但把「稿费单价怎么定、收益怎么算、多久结算、怎么提现」一条线讲透的却不多。
            我们把这些信息整理成一份能直接照着做的攻略。
          </p>
          <div className="mt-7 grid gap-4 sm:grid-cols-3">
            {points.map((p) => (
              <div key={p.title} className="rounded-2xl bg-background-50 p-5 ring-1 ring-background-200">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-2xl text-accent-700">
                  <i className={p.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 font-semibold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}